// @flow
const FLIP = 'flashcard:flip';
const UNFLIP = 'flashcard:unflip';
const SKIP = 'flashcard:skip';
const BACK = 'flashcard:go-back';
const NEXT = 'flashcard:go-next';
const ANSWER = 'flashcard:answer';

const SHOW = 'flashcard:show';
const START_SESSION = 'flashcard:start-session';
const STOP_SESSION = 'flashcard:stop-session';
const COMPLETE_SESSION = 'flashcard:session-complete';
const START_NEXT_BATCH = 'flashcard:startNextBatch';
/*
Things that can be added:
1) Breakpoint handling:
    If and when we add motivational
    and/or pedagogical breakpoints
2) Revisit skipped:
    We can allow the user to revisit the cards
    that they skipped
3) Go to last viewed:
    If we want the user to go to the next card
    quickly if they had wandered too far out in
    the back.
4) Handling mode change (Reverse <-> Forward)
*/

export {
  ANSWER,
  BACK,
  NEXT,
  COMPLETE_SESSION,
  FLIP,
  SKIP,
  SHOW,
  START_SESSION,
  STOP_SESSION,
  UNFLIP,
  START_NEXT_BATCH,
};
